<template>
    <gofix-card title=" " classHeader="p-0 m-0" class="heig-frame-child" fullContent>
        <gofix-table
                class="noFullHeight scrollAbsolute"
                :settings="tableConfig"
                :table-items="tableItems"
                @load-items="getTableData"
                @new-item="openModal"
                @row-click="openModal"
                @delete-items="deleteItems"
                ref="gofixTable">
        </gofix-table>
        <b-modal :no-close-on-backdrop="true" modal-class="createFmCode" id="modal-Create" :title="modal.title" hide-footer :centered="true" v-model="modal.open">
            <b-form class="pb-20">
                <gofix-form-input label="Tag Name" v-model="modal.data.reference_value_text" required></gofix-form-input>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="SUBMIT" @click="save" :loading="modal.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>
<script>
    import { mapGetters } from 'vuex';
    export default {
        name: 'settings-reasons-order',
        props: {
            referenceType: {
                require: true,
                default: ''
            }
        },
        data () {
            return {
                tableConfig:{
                    name: 'case-setting-tags',
                    controls:{
                        createTooptip:"Create Reason",
                    },
                    filter: {
                       reference_value_text: {	type: "text", value: "", function: "ilike", with: [] },
                       reference_type: 		 {	type: 'text', value: this.referenceType, function:"=", with: [] },
                       contract_id: 		 {	type: "number", value: this.$route.params.id, function: "=", with: [] },
                    },
                    page: 1,
                    total: 0,
                    //isCMS: false,
                    useDatabaseView: false,
                    sortColumn: "reference_value_text",
                    sortDirection: "asc",
                    itemSelected: [],
                    fields: [
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'checkbox-column text-center',
                            tdClass: 'checkbox-column text-center',
                            width: 50,
                            thStyle: "width:50px",
                        },
                        {
                            key: 'reference_value_text',
                            label: 'Tag Name',
                            placeholder: 'search',
                            isActive: 1,
                            isFilter: true,
                            with:null,
                            thStyle: "width:nullpx",
                            sorting: true,
                        },
                    ]
                },
                tableItems:[],
                modal:{
                    open: false,
                    loading: false,
                    title:"New Tag",
                    data:{
                        id: null,
                        reference_type: this.referenceType,
                        reference_value_text: null,
                        contract_id: this.$route.params.id,
                    },
                },
            }
        },
        computed: {
            ...mapGetters({
                UserLogin: "AuthController/user",
                ClientContractID: 'ContractController/ClientContractID',
                currentRoles: 'AuthController/roles',
            }),
        },
        methods:{
            //Load data list
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                tableRequest.filter.contract_id.value = this.$route.params.id;
                await this.$store.dispatch("ReferenceController/getItems", tableRequest)
                    .then(response => {
                        this.tableItems = response.items;
                        this.tableConfig.total = response.total;
                        resolve(response);
                    })
                    .catch(err => {
                        this.$bvToast.toast("Can not load the data", {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'danger',
                            solid: true
                        })
                        reject();
                    })
            },

            //Open modal Edit || Create data
            openModal(item){
              if(item){
                  this.modal.title = "Edit Tag";
                  this.modal.data = {
                      id: item.id,
                      reference_type: item.reference_type,
                      reference_value_text: item.reference_value_text,
                      contract_id: this.$route.params.id,
                  }
              }else{
                  this.modal.title = "New Tag";
                this.modal.data = {
                    id: null,
                    reference_type: this.referenceType,
                    reference_value_text: null,
                    contract_id: this.$route.params.id,
                }
              }
              this.modal.open = true;
            },

            //Update & Create data
            save(){
                if(!this.modal.data.reference_value_text){
                    return this.$bvToast.toast('Tag name is a required field.', {
                        title: `Notification`,
                        autoHideDelay: 3000,
                        variant: 'danger',
                        solid: true
                    })
                }
                let method    = 'createItem';
                let msg    = 'added';
                if(this.modal.data.id) {
                    method = 'updateItem';
                    msg    = 'updated';
                }
                this.$store.dispatch(`ReferenceController/${method}`, this.modal.data)
                    .then(result => {
                        this.$bvToast.toast( `Successfully ${msg} tag`, {
                            title: `Notification`,
                            autoHideDelay: 3000,
                            variant: 'success',
                            solid: true
                        });
                        this.modal.open = false;
                        this.$refs['gofixTable'].reloadTableKeepFilter();
                    })
                    .catch(error => {
                        if(error.response && error.response.data.error.message.error) {
                            return this.$bvToast.toast(error.response.data.error.message.error, {
                                title: `Notification`,
                                autoHideDelay: 3000,
                                variant: 'danger',
                                solid: true
                            });
                        }
                    })
            },

            //Delete data
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                this.$store.dispatch("ReferenceController/deleteItem", ids)
                    .then(response => {
                        resolve("Successfully deleted tag");
                    })
                    .catch(err =>{
                        reject(err);
                    });
            },
        }
    }
</script>
